module.exports = __webpack_public_path__ + "static/img/bystage_white_10.ad0b72f4.svg";